import {
  Image,
  ImageStyle,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import Label from '../../../Label';
import {styles} from './styles';

interface MoreInfoProps {
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  status: boolean;
  onCollapse: (vaue: boolean) => void;
}
export const MoreInfo = ({
  children,
  style,
  status,
  onCollapse,
}: MoreInfoProps) => {
  return (
    <View style={[{flex: 1}, style]}>
      <TouchableOpacity
        style={styles.moreInfoContainer}
        onPress={() => onCollapse(!status)}>
        <Label
          style={{justifyContent: 'center'}}
          textStyle={{fontSize: 20}}
          title={`Plus d'info`}
        />
        <Image
          style={
            {
              width: 40,
              height: 40,
              transform: [{rotate: status ? '180deg' : '0deg'}],
            } as ImageStyle
          }
          // eslint-disable-next-line @typescript-eslint/no-require-imports
          source={require('../../../../../ressources/images/arrow_drop_down.png')}
        />
      </TouchableOpacity>
      {status && children ? children : null}
    </View>
  );
};
